export enum OrderView {
  EDIT = 'edit',
  FINISHED = 'finished',
  SUGGESTION = 'suggestion',
}
